export default __webpack_public_path__ + "static/media/arrow-right.023b7f73.svg";